import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

export const Footer = () => {
  const { settings } = useSettings();
  const s = settings || {};
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-900 py-12 relative overflow-hidden">
      <div className="absolute -top-20 right-1/4 w-96 h-96 bg-orange-600 rounded-full mix-blend-overlay filter blur-3xl opacity-10"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-12 gap-8 items-start mb-10">
          <div className="md:col-span-5">
            <div className="bg-white rounded-lg inline-block px-3 py-2 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_d17b1037-2ee5-4a1e-b027-553c006871ab/artifacts/susrxk43_creator_first_logo.png"
                alt="Creator First"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed max-w-md">
              {s.footer_description || "India's trusted influencer marketing and talent management agency. Building authentic connections between brands and creators."}
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs font-bold tracking-[0.2em] text-orange-400 uppercase mb-4">Navigate</h3>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-400 hover:text-orange-400 transition-colors">About</a></li>
              <li><a href="#brands" className="text-gray-400 hover:text-orange-400 transition-colors">Brands</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-orange-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-xs font-bold tracking-[0.2em] text-orange-400 uppercase mb-4">Connect</h3>
            <div className="flex gap-3 mb-4">
              <a
                href={s.instagram_url || 'https://www.instagram.com/shashankmohan96/'}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-gray-700 hover:border-orange-500 hover:bg-orange-500 flex items-center justify-center transition-all group"
                data-testid="footer-instagram"
              >
                <Instagram size={18} className="text-gray-400 group-hover:text-white transition-colors" />
              </a>
              <a
                href={s.linkedin_url || 'https://www.linkedin.com/in/shashank-mohan-yadav/'}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-gray-700 hover:border-orange-500 hover:bg-orange-500 flex items-center justify-center transition-all group"
                data-testid="footer-linkedin"
              >
                <Linkedin size={18} className="text-gray-400 group-hover:text-white transition-colors" />
              </a>
            </div>
            <p className="text-sm text-gray-500">{s.domain || 'creatorfirst.in'}</p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-sm text-gray-500">© {currentYear} Creator First. All rights reserved.</p>
          <p className="text-xs font-bold tracking-[0.2em] text-gray-600 uppercase">Talent · Influence · Growth</p>
        </div>
      </div>
    </footer>
  );
};
